import { useParams } from 'react-router';

export const useNegotiationDetail: () => { negotiationId: string } = () => {
  return useParams() as any;
};
export const useOrderDetail: () => { orderId: string } = () => {
  return useParams() as any;
};
export const useContractDetail: () => { contractId: string } = () => {
  return useParams() as any;
};
export const useSupplierDetail: () => { supplierId: string } = () => {
  return useParams() as any;
};
export const useCompanyDetail: () => { companyId: string } = () => {
  return useParams() as any;
};
export const usePurchaseRequisitionDetail: () => { purchaseRequisitionId: string } = () => {
  return useParams() as any;
};
export const useCommodityDetail: () => { commodityId: string } = () => {
  return useParams() as any;
};
export const useCommodityGroupDetail: () => { commodityGroupId: string } = () => {
  return useParams() as any;
};
export const useSourcingProjectDetail: () => { useSourcingProjectId: string } = () => {
  return useParams() as any;
};
export const useTabId: () => { tabId?: string } = () => {
  return useParams() as any;
};
export const useDemandDetail: () => { demandId: string } = () => {
  return useParams() as any;
};
export const useChatSession: () => { id: string } = () => {
  const { id } = useParams();
  return { id } as { id: string };
};
export const useRiskDetail: () => { id: string; tabId?: string } = () => {
  return useParams() as { id: string; tabId?: string };
};
export const useRiskCountryReport: () => { id: string; tabId?: string } = () => {
  return useParams() as { id: string; tabId?: string };
};
export const useUserDetail: () => { userId: string | undefined } = () => {
  return useParams() as any;
};
export const useRuleDetail: () => { ruleId: string } = () => {
  return useParams() as any;
};
export const useSourcingCase: () => { id: string; tabId?: string } = () => {
  const { id, tabId } = useParams();
  return { id, tabId } as { id: string; tabId?: string };
};
